<template>
	<v-layout row v-if="!dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<choose-volunteers
				:readonly="true"
				:value="old"
				:global-init="oldGlobalInit"
				:global-init-description="oldGlobalInitDescription"
			/>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<choose-volunteers
				:readonly="true"
				:value="current"
				:global-init="currentGlobalInit"
				:global-init-description="currentGlobalInitDescription"
			/>
		</v-flex>
	</v-layout>
</template>
<script>
	import NewVersionMarker from "./NewVersionMarker";
	import OldVersionMarker from "./oldVersionMarker";
	import ChooseVolunteers from "../components/ChooseVolunteers";

	export default {
		name: 'compareVolunteers',
		components: {ChooseVolunteers, NewVersionMarker, OldVersionMarker},

		computed: {
			dataSame () {
				let comparisonResult = JSON.stringify(this.current) === JSON.stringify(this.old) &&
					this.currentGlobalInit === this.oldGlobalInit &&
					this.currentGlobalInitDescription === this.oldGlobalInitDescription;
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			current: {},
			currentGlobalInit: Boolean,
			currentGlobalInitDescription: String,
			old: {},
			oldGlobalInit: Boolean,
			oldGlobalInitDescription: String,
		}
	};
</script>
